import React, { useMemo } from "react";

import InitialDataListPage from "../components/InitialDataListPage";
import { formatDate } from "../../../../utils/DateUtils";

const EmployeeMain = ({
  masterList = [],
  name,
  onPageInsert,
  onRowSelected,
}) => {
  const columns = useMemo(
    () => [
      {
        key: "index",
        header: "#",
        width: "6%",
        align: "center",
        render: (_item, _index, { startIndex, itemIndex }) =>
          startIndex + itemIndex + 1,
      },
      {
        key: "Emp_Code",
        header: "รหัสพนักงาน",
        width: "12%",
        align: "center",
        render: (item) => item.Emp_Code || "-",
      },
      {
        key: "Emp_Name",
        header: "ชื่อ",
        width: "26%",
        align: "start",
        render: (item) => item.Emp_Name || "-",
      },
      {
        key: "PST_Name",
        header: "ตำแหน่ง",
        width: "20%",
        align: "start",
        render: (item) => item.PST_Name || "-",
      },
      {
        key: "Emp_StartDate",
        header: "วันที่เริ่มงาน",
        width: "14%",
        align: "center",
        render: (item) =>
          item.Emp_StartDate ? formatDate(item.Emp_StartDate) : "-",
      },
      {
        key: "Emp_Tel",
        header: "เบอร์โทร",
        width: "14%",
        align: "center",
        render: (item) => item.Emp_Tel || "-",
      },
      {
        key: "Emp_Status",
        header: "สถานะ",
        width: "12%",
        align: "center",
        render: (item) =>
          item.Emp_Status === "Y" ? "ใช้งาน" : "ไม่ใช้งาน",
      },
      {
        key: "actions",
        header: "แก้ไข",
        width: "6%",
        align: "center",
        isAction: true,
        render: (item, _index, { triggerRowSelected }) => (
          <button
            onClick={(event) => {
              event.stopPropagation();
              triggerRowSelected(item);
            }}
            className="btn btn-sm"
            title="แก้ไข"
            style={{
              width: "32px",
              height: "32px",
              borderRadius: "8px",
              border: "none",
              backgroundColor: "#fff3e0",
              color: "#EF6C00",
              transition: "all 0.2s ease",
            }}
            onMouseOver={(event) => {
              event.currentTarget.style.backgroundColor = "#EF6C00";
              event.currentTarget.style.color = "#fff";
            }}
            onMouseOut={(event) => {
              event.currentTarget.style.backgroundColor = "#fff3e0";
              event.currentTarget.style.color = "#EF6C00";
            }}
            type="button"
          >
            <i className="fas fa-edit" />
          </button>
        ),
      },
    ],
    []
  );

  const getSearchValues = useMemo(
    () => (item) => [
      item?.Emp_Code,
      item?.Emp_Name,
      item?.PST_Name,
      item?.Emp_Tel,
      item?.Emp_Status === "Y" ? "ใช้งาน" : "ไม่ใช้งาน",
    ],
    []
  );

  return (
    <InitialDataListPage
      name={name}
      entityPath="/employee"
      data={masterList}
      onCreate={onPageInsert}
      onRowSelected={onRowSelected}
      columns={columns}
      getSearchValues={getSearchValues}
      fieldMappings={{ no: "Emp_Id" }}
      getRowId={(item) => item?.Emp_Id}
    />
  );
};

export default EmployeeMain;
